import { useSelector } from "react-redux"
import { getUserProfile } from ".."

export default function useUserProfile() {
  return useSelector(getUserProfile);
}
